// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import VueResource from 'vue-resource';
import App from './App';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(VueResource);

let instance = null;
Vue.http.interceptors.push((request, next) => {
	// continue to next interceptor

	next((response) => {
		store.dispatch('setAccessErrorStatusCode', response.status);

		/* Zur Login-Maske, wenn nicht autorisiert -> Token wahrscheinlich ungültig */
		if ([401, 403].includes(response.status) && instance.$router) {
			if (instance.$route.path === '/login') return;
			instance.$router.push({
				path: '/login',
				query: { redirect: instance.$route.path },
			});
		}
	});
});

// Initialisiere Global- und Authentifizierungs-State
store.dispatch('globalInitialize');
store.dispatch('userInitialize').catch(() => {
	 /* TODO: Use (better) logging */
});

/* eslint-disable no-new */
instance = new Vue({
	el: '#app',
	router,
	store,
	template: '<App/>',
	components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js